import Pikaday from "pikaday";

moment.locale("ru");
export const PikadayI18n = {
    previousMonth: "Предыдущий месяц",
    nextMonth    : "Следущий месяц",
    months       : moment.months(),
    weekdays     : moment.weekdays(),
    weekdaysShort: moment.weekdaysShort()
};

export default {
    config : {},
    install: (Vue) => {
        Vue.directive("date", {
            bind(el, binding) {
                el.pikadayInstance = new Pikaday({
                    field: el,
                    i18n : PikadayI18n,
                    ...binding.value,
                });
            },

            update(el, binding) {
                // console.log(binding.value);
                el.pikadayInstance.destroy();

                el.pikadayInstance = new Pikaday({
                    // defaultDate: "",
                    field      : el,
                    theme      : "pika--themed",
                    i18n       : PikadayI18n,
                    ...binding.value
                });
            },

            unbind(el) {
                el.pikadayInstance.destroy();
                delete el.pikadayInstance;
            }
        })
    }
};



// WEBPACK FOOTER //
// ./application/components/general/VuePickadayDirective.js